import { MultiSelect } from './MultiSelect'
import { Select } from './Select'
import type { FilterBarProps } from '../types'
import styles from '../index.module.css'

const monthName = (offset: number) => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth() + offset, 1).toLocaleString(
    'en-US',
    { month: 'long' },
  )
}

const MONTH_OPTIONS = [
  { value: 'Last Month', label: `Last Month - ${monthName(-1)}` },
  { value: 'Current Month', label: `Current Month - ${monthName(0)}` },
  { value: 'Next Month', label: `Next Month - ${monthName(1)}` },
]

export default function FilterBar({
  agentName,
  month,
  onMonthChange,
  statusFilter,
  onStatusFilterChange,
  allStatuses,
}: FilterBarProps) {
  const statusOptions = allStatuses.map((s) => ({ value: s, label: s }))

  return (
    <div className={styles.filterBar}>
      <div className={styles.chip}>
        <span className={styles.chipLabel}>Agent:</span>
        <span className={styles.chipValue}>{agentName || '—'}</span>
      </div>

      <div className={styles.chip}>
        <span className={styles.chipLabel}>Month:</span>
        <Select
          value={month}
          onChange={onMonthChange}
          options={MONTH_OPTIONS}
        />
      </div>

      <div className={styles.chip}>
        <span className={styles.chipLabel}>File Status:</span>
        <MultiSelect
          values={statusFilter}
          onChange={onStatusFilterChange}
          options={statusOptions}
          placeholder="All"
        />
      </div>
    </div>
  )
}
